export const JobListSeparator = () => (
  <div className="w-full border-t border-slate-200 col-span-7"/>
);
